/**
 * Utility functions to assist in date formatting related processing.
 */

import moment from 'moment';

/**
 * Returns a formatted date time string for the current time to the user.
 */
export const getCurrentTimeForCard = () => moment(moment.now()).format("MMM DD, hh:mm A");

/**
 * Formats a unix date number into a formatted date string for display to the user.
 * @param dateNum to be formatted
 * @returns {string} formatted date used for longer titles.
 * @see {@link https://www.npmjs.com/package/moment}
 * for more information.
 */
export const getFormattedDateForTitle = (dateNum) => {
    return moment.unix(dateNum / 1000).format("MMM DD, YYYY, hh:mm A");
};

/**
 * Formats a unix date number into a formatted date string for searching date keywords.
 * {@example February, Feb, }
 * @param dateNum to be formatted
 * @returns {string} formatted date used for search parameters
 * @see {@link https://www.npmjs.com/package/moment}
 * for more information.
 */
export const getFormattedDateForSearch = (dateNum) => {
    return moment.unix(dateNum / 1000).format("MMM MMMM YYYY D ddd dddd A").toLowerCase();
};

/**
 * Formats a unix date number into a formatted date string in
 * {@format x years, y days ago ...} for display to the user.
 * @param dateNum to be formatted
 * @returns {string} formatted date used for longer titles.
 * @see {@link https://www.npmjs.com/package/moment}
 * for more information.
 */
export const getDaysAgo = (dateNum) => {
    const now = moment(moment.now());
    const then = moment(moment.unix(dateNum / 1000));
    return moment.duration(now.diff(then)).humanize();
};

/**
 * Formats a unix date number into a formatted date string for display to the user.
 * @param dateNum to be formatted
 * @param format to be displayed using.
 * @returns {string} formatted date based on the given {@param format}.
 * @see {@link https://www.npmjs.com/package/moment}
 */
export const getFormattedDate = (dateNum, format) => {
    return moment.unix(dateNum / 1000).format(format);
};

/**
 * Formats a duration in seconds into a formatted string to be displayed.
 * @param totalSeconds to be converted
 * @returns {string} formatted duration.
 */
export const getFormattedDuration = (totalSeconds) => {
    if (!totalSeconds) {
        totalSeconds = 0;
    }

    const minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds - (minutes * 60);

    // round seconds
    seconds = Math.round(seconds * 100) / 100;

    let result = (minutes < 10 ? "0" + minutes : minutes);
    result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
    return result;
};



// WEBPACK FOOTER //
// ./src/utils/date.js